import React from "react"
import Typography from "../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import Button from "../../reusable/components/Button"

type Props = {
    isListView?: boolean
    imageSrc: string
    headerTitle: string
    description: string
    btnIconSrc: string
    btnLabel: string
    href: string
}
function CTA({isListView = false, imageSrc, headerTitle, description, btnIconSrc, btnLabel, href}: Props) {
	const {t} = useTranslation()
	const router = useRouter()
	if (isListView) {
		return (
			<div className="d-flex justify-content-start gap-3 align-items-start">
				<img src={imageSrc}
					height={124}
					width={124} />
				<div className="d-flex flex-column aling-items-start gap-1 justify-content-start">
					<Typography variant="bodySmBold"
						semanticTag="h1"
						style={{fontsize: "16px", lineHeight: "24px"}}>{headerTitle}</Typography>
					<Typography variant="bodySm"
						semanticTag="h1"
						style={{fontsize: "14px", lineHeight: "20px", fontWeight: "500"}}>{description}</Typography>

					<Button href={href}
						className="col-6"
						bgColor="#FEC04D"
						fontSizeSmall
						label={btnLabel}
						iconFirst
						icon={<img src={btnIconSrc}
							alt="question mark"/>} />
				</div>
			</div>
		)
	}

	return <div style={{border: "solid 1px #DEE2E6", minWidth: "254px", minHeight: "418px", padding: "16px", borderRadius: "16px"}}
		className="d-flex bg-white flex-column justify-content-center gap-3 align-items-center">
		<img className="col-12"
			src={imageSrc} />
		<div className="d-flex flex-column aling-items-center gap-1 justify-content-start">
			<Typography variant="bodySmBold"
				semanticTag="h1"
				style={{fontsize: "16px", lineHeight: "24px"}}>{headerTitle}</Typography>
			<Typography variant="bodySm"
				semanticTag="h1"
				style={{fontsize: "14px", lineHeight: "20px", fontWeight: "500"}}>{description}</Typography>

			<Button href={href}
				className="col-12"
				btnFontSize={14}
				bgColor="#FEC04D"
				label={btnLabel}
				iconFirst
				icon={<img src={btnIconSrc}
					alt="question mark"/>} />
		</div>
	</div>
}

export default CTA
